import * as MentionsPickerConstants from '../constants';
import {
    MentionPluginDataProvider,
    WellModifierFunctionType,
} from '../providers/MentionPluginDataProvider';
import AtMentionsViewState from '../store/schema/AtMentionsViewState';
import { EditorViewState, PluginViewStateAdapter, PluginWithUI } from 'owa-editor';
import ReadWriteRecipientViewState from 'owa-recipient-types/lib/types/ReadWriteRecipientViewState';
import { PickerPlugin } from 'roosterjs-editor-plugins/lib/Picker';
import AtMentionsResult from '../components/AtMentionsResult';
import { PluginEvent, PickerPluginOptions, PluginEventType } from 'roosterjs-editor-types';
import getMentionClassName from '../utils/getMentionClassName';

export default class AtMentionPickerPlugin
    extends PickerPlugin<MentionPluginDataProvider>
    implements PluginWithUI<AtMentionsViewState> {
    readonly adapter: PluginViewStateAdapter<AtMentionsViewState>;
    readonly editorAdapter: PluginViewStateAdapter<EditorViewState>;
    constructor(
        adapter: PluginViewStateAdapter<AtMentionsViewState>,
        editorAdapter: PluginViewStateAdapter<EditorViewState>,
        addSelectedPersonaToWell: WellModifierFunctionType,
        removePersonaFromWell: WellModifierFunctionType,
        onRecipientAdded: () => void,
        canModifyRecipients: boolean,
        getAllRecipients: () => ReadWriteRecipientViewState[]
    ) {
        const provider = new MentionPluginDataProvider(
            adapter,
            addSelectedPersonaToWell,
            removePersonaFromWell,
            onRecipientAdded,
            canModifyRecipients,
            getAllRecipients
        );
        const pickerOptions: PickerPluginOptions = {
            elementIdPrefix: MentionsPickerConstants.AT_MENTION_ELEMENT_ID_PREFIX,
            changeSource: MentionsPickerConstants.AT_MENTION_CHANGE_SOURCE,
            triggerCharacter: MentionsPickerConstants.AT_MENTION_TRIGGER_CHARACTER,
            suggestionsLabel: MentionsPickerConstants.AT_MENTION_RECIPIENT_SUGGESTIONS_LABEL,
            suggestionLabelPrefix:
                MentionsPickerConstants.AT_MENTION_RECIPIENT_SUGGESTION_LABEL_PREFIX,
        };

        super(provider, pickerOptions);
        this.adapter = adapter;
        this.editorAdapter = editorAdapter;
    }

    public getUIComponentClass() {
        return AtMentionsResult;
    }

    public getName() {
        return 'AtMentionsPicker';
    }

    public onPluginEvent(event: PluginEvent) {
        if (event.eventType == PluginEventType.BeforePaste) {
            event.sanitizingOption.additionalAllowedCssClasses.push(getMentionClassName());
        }

        super.onPluginEvent?.(event);
    }
}
